import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Radio, Paper } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';
import { Button } from '@material-ui/core';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
}));

const useStyles = makeStyles((_theme) => ({
  header: {
    color: "var(--Neutral-Colors-Text-Black, #333)",
    fontFamily: 'Poppins, sans-serif',
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "normal",
    flex: 1
  },
  radio: {
    '& .MuiIconButton-root .MuiSvgIcon-root': {
      width: '12px',
      height: '12px',
      color: "#FF8200"
    },
  },
}));

const ReportDialogBox = ({ handleClose, open }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("");

  const handleDialogClose = () => {
    handleClose();
  };

  const handleChange = (value) => {
    setSelectedValue(value);
  };
  const handleClick=()=>{
    navigate("/OSMPowerApp");
  };
  return (
    <BootstrapDialog
      onClose={handleDialogClose}
      aria-labelledby="customized-dialog-header"
      open={open}
      PaperProps={{
        style: {
          backgroundColor: '#F5F7F4',
          borderRadius: '10px',
          width: '300px',
          padding: '20px'
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 1, fontSize: 16, fontWeight: 600 }} id="customized-dialog-header">
        Go to
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ padding: "0px" }}>
      <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', margin: "10px 0px", height: "40px", borderRadius: "6px" }}>
          <Radio
            value="Today's recommendations"
            checked={selectedValue === "Today's recommendations"}
            onChange={() => handleChange("Today's recommendations")}
            size="small"
            inputProps={{ 'aria-label': "Today's recommendations" }}
            className={classes.radio}
            sx={{
              color: "#FF8200",
              '&.Mui-checked': {
                color: "#FF8200",
              },
            }}
          />
          <span className={classes.header}>Today's recommendations</span>
        </Paper>
        <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', margin: "10px 0px", height: "40px", borderRadius: "6px" }}>
          <Radio
            value="Monthly report"
            checked={selectedValue === "Monthly report"}
            onChange={() => handleChange("Monthly report")}
            size="small"
            inputProps={{ 'aria-label': "Monthly report" }}
            className={classes.radio}
            sx={{
              color: "#FF8200",
              '&.Mui-checked': {
                color: "#FF8200",
              },
            }}
          />
          <span className={classes.header}>Monthly report</span>
        </Paper>
        <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', margin: "10px 0px", height: "40px", borderRadius: "6px" }}>
          <Radio
            value="Daily report"
            checked={selectedValue === "Daily report"}
            onChange={() => handleChange("Daily report")}
            size="small"
            inputProps={{ 'aria-label': "Daily report" }}
            className={classes.radio}
            sx={{
              color: "#FF8200",
              '&.Mui-checked': {
                color: "#FF8200",
              },
            }}
          />
          <span className={classes.header}>Daily report</span>
        </Paper>
        <Paper elevation={0} style={{ display: 'flex', alignItems: 'center', margin: "10px 0px", height: "40px", borderRadius: "6px" }}>
          <Radio
            value="Power App"
            checked={selectedValue === "Power App"}
            onChange={() => handleChange("Power App")}
            size="small"
            inputProps={{ 'aria-label': 'Power App' }}
            className={classes.radio}
            sx={{
              color: "#FF8200",
              '&.Mui-checked': {
                color: "#FF8200",
              },
            }}
          />
          <span className={classes.header}>Power App</span>
        </Paper>
        <div style={{display:"flex",justifyContent:"center"}}>
      <Button variant="contained" style={{margin:"15px 0px",color:"#ffffff", background:"#054E9C",width: "80px",fontSize:"12px",alignItems:"center"}} onClick={handleClick}
      >
            Go 
      </Button>
      </div>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ReportDialogBox;
